export default {
  payoutIsAvailable(state) {
    return state.wallet && state.wallet.payoutEnabled && state.wallet.balance > 0
  },
}
